import KpiIndicator from "../KpiIndicator";
import PeriodDatesPickerContainer from "../../PeriodDatesPickerContainer";
import Z3 from "../../Z3SideContainer";
import { Checkbox, Col, Drawer, Row, Icon, Tooltip, Modal, Button, Badge } from "antd";
import DimensionsView from "../Dimension/Dimensions";
import Export from "../Export";
import Kpis from "../filters/Kpis";
import Dimensions from "../filters/Dimensions";
import Z4 from "../../Z4Container";
import Z5 from "../../Z5Container";
import Z6 from "../../Z6PeriodsContainer";
import React, { useState } from "react";
import "./Dimension.css";

const Dimension = ({ changePeriodFromSelect, IsComparingActivate, nbSelectedFilters, setGainChecked, isDataDisplayed, onToggleDataDisplayed }) => {
  const [isComparing, setIsComparing] = useState(IsComparingActivate);
  const [isFilterSectionVisible, setFilterSectionVisible] = useState(false);
  const [isFilterPeriodVisible, setFilterPeriodVisible] = useState(false);

  const onToggleCheckbox = e => {
    setIsComparing(e.target.checked);
    setGainChecked(e.target.checked);
    if (!e.target.checked) {
      changePeriodFromSelect(null, "periodToCompare");
    }
  };

  return (
    <div className="p-stats">
      <div className="p-stats-content p-al-full p-al-wrap">
        <div className="p-stats-container" style={{ width: "100%" }}>
          {/*Content top menu*/}

          <Row style={{ padding: 10 }}>
            <Col xs={24} md={24} lg={20} xl={16}>
              <Row
                gutter={16}
                style={{
                  height: 100,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }}
              >
                <Col span={10}>
                  <KpiIndicator />
                </Col>
                <Col
                  span={14}
                  className="p-stats-indicator-period"
                  style={{
                    height: 100
                  }}
                >
                  <Row gutter={16} style={{ height: 100 }}>
                    <Col id="ComparePeriod" span={18}>
                      <div className="p-page-subtitle p-stats-indicator-label">Période</div>
                      <PeriodDatesPickerContainer isComparing={isComparing} />
                    </Col>
                    <Col span={3}>
                      <div
                        className={`filter-btn`}
                        style={{ marginTop: 33 }}
                        onClick={() => {
                          setFilterPeriodVisible(true);
                        }}
                      >
                        <Icon type="setting" />
                      </div>
                    </Col>
                    <Col span={3} className="Dimension__checkbox">
                      <span>Gain</span>
                      <Checkbox onChange={onToggleCheckbox} checked={isComparing}></Checkbox>

                      <Modal
                        title="Périodes"
                        visible={isFilterPeriodVisible}
                        onOk={() => setFilterPeriodVisible(false)}
                        onCancel={() => setFilterPeriodVisible(false)}
                        footer={[
                          <Button key="submit" type="primary" onClick={() => setFilterPeriodVisible(false)}>
                            Fermer
                          </Button>
                        ]}
                      >
                        <Z6 />
                      </Modal>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs={0} md={0} lg={4} xl={8}>
              <div className="logo"></div>
              <div className="flex flex-col items-center justify-center">
                <div className="mb-2">
                  <span>chargement des graphiques</span>
                </div>
                <Checkbox onChange={onToggleDataDisplayed} checked={isDataDisplayed}></Checkbox>
              </div>
            </Col>
          </Row>

          {/*Content grid container*/}
          <div className="" style={{ margin: 10, marginTop: 20 }}>
            <Row gutter={16}>
              <Col span={4}>
                <Kpis />
              </Col>
              <Col span={16}>
                <Dimensions />
              </Col>
              <Col span={4}>
                <Row>
                  <Col span={10}>
                    <Badge count={nbSelectedFilters}>
                      <Icon
                        className="filter-btn"
                        onClick={() => {
                          setFilterSectionVisible(true);
                        }}
                        type="filter"
                      />
                    </Badge>

                    <Drawer
                      title="Filtres"
                      placement="right"
                      closable={true}
                      onClose={() => {
                        setFilterSectionVisible(false);
                      }}
                      visible={isFilterSectionVisible}
                      getContainer={() => document.getElementById("root")}
                      style={{ position: "absolute" }}
                      bodyStyle={{ paddingBottom: 80 }}
                      drawerStyle={{ width: 500 }}
                      width="470"
                    >
                      <div className=" p-content-item p-stats-filters">
                        <Z3 hideDimensionFilter={false} />
                        <Z4 />
                        <Z5 />
                      </div>
                    </Drawer>
                  </Col>
                  <Col span={14}>
                    <Export style={{ float: "right" }} />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row
              gutter={16}
              style={{
                marginTop: 10,
                padding: 5,
                height: "calc(100vh - 330px)",
                position: "relative",
                overflow: "hidden auto"
              }}
            >
              <DimensionsView />
            </Row>
            {/*<Row gutter={16} style={{ marginTop: 20 }}>
              <Col offset={18} span={6}>
                <Export />
              </Col>
            </Row>*/}
          </div>
        </div>

        {/*Filters (side)*/}
        {/*<div className="p-w-1-5 p-content-item p-stats-filters">
          <Divider>Filtres</Divider>
          <Z3 hideDimensionFilter={false} />
          <Z4 />
          <Z5 />
        </div>*/}
      </div>
    </div>
  );
};

export default Dimension;



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/views/Dimension.js